import React from "react";
import { GridCell } from "@progress/kendo-react-grid";
import { Link } from "react-router-dom";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { LocalStorageService, ContractService } from "../../../services";
import { ArrowBtnMobile } from "../../../assets/logos/icons";

function extractDocumentId(item) {
  if (!item) return null;
  const direct = item.documentId || item.document_id || item.registrationDocumentId || item.clientDocumentId || item.idDocument
  if (direct) return direct
  try {
    if (item.solicitudeAdditionalData) {
      const parsed = typeof item.solicitudeAdditionalData === 'string'
        ? JSON.parse(item.solicitudeAdditionalData)
        : item.solicitudeAdditionalData
      if (parsed && typeof parsed === 'object') {
        return parsed.documentId || parsed.docId || parsed.registrationDocumentId || null
      }
    }
  } catch (_) { /* ignore */ }
  return null
}

function isUuidLike(value) {
  if (!value || typeof value !== 'string') return false
  const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
  return uuidRegex.test(value)
}


function Container({
  children,
  solicitudeUrl,
  setIsShowAutorizationModal,
  userTypeId,
  killMe,
  dataItem
}) {
  let finalUrl

  if (solicitudeUrl) {
    finalUrl = typeof solicitudeUrl === "object"
      ? {
        pathname:
          solicitudeUrl.pathname?.startsWith("/")
            ? solicitudeUrl.pathname
            : `/${solicitudeUrl.pathname || ""}`,
        search: solicitudeUrl.search || "",
      }
      : `/${solicitudeUrl || ""}`
  } else {
    const docId = extractDocumentId(dataItem)
    if (isUuidLike(String(docId))) {
      finalUrl = {
        pathname: "/digital-vault/bin",
        search: `?documentId=${docId}&fromDelete=true`
      }
    } else if (dataItem?.expedienteId) {
      finalUrl = {
        pathname: "/digital-vault/bin",
        search: `?expedienteId=${dataItem.expedienteId}&fromDelete=true`
      }
    } else {
      finalUrl = { pathname: "/digital-vault/bin", search: `?autoOpen=true&fromDelete=true` }
    }
  }

  if (userTypeId) {
    return <Link to={finalUrl}>{children}</Link>;
  } else if (killMe) {
    return (
      <a onClick={killMe} className="primaryBtn">
        {children}
      </a>
    );
  } else {
    return (
      <a
        onClick={() => setIsShowAutorizationModal(true)}
        className="primaryBtn"
      >
        {children}
      </a>
    );
  }
}

export default function cellDetailSignatureRequest({
  edit,
  styleCol4,
  seeDetail,
  tooltipDetail,
  tooltipTracking,
  tooltipDelete,
  toggleDialogDeleteRequest,
  view,
  visibilityIcon,
  setIsShowAutorizationModal,
  isHideTrash,
  killMe,
}) {
  return class extends GridCell {
    localStorageService = new LocalStorageService();
    contractService = new ContractService(process.env.REACT_APP_MIFIRMA_API);

    state = {
      miFirmaId: 0,
    };
    componentDidMount = async () => {
      let user = await this.localStorageService.getLocalStorageItem("user");
      let contractUser =
        this.localStorageService.getLocalStorageItem("contractUserExist");
      let contactExist =
        contractUser &&
          contractUser.data?.userHadContracts &&
          contractUser.data?.userHadContracts !== ""
          ? contractUser.data?.userHadContracts
          : true;
      this.props.dataItem.contactExistFlag = contactExist;
      this.setState({
        miFirmaId: user.userMetaData.userMifirma.id,
        clientId: user.userMetaData.userMifirma.clientId,
      });
    };
    render() {
      let user = this.localStorageService.getLocalStorageItem("user");
      const { inboxTypeId } = this?.props?.dataItem;
      let { showCancel } = this?.props?.dataItem
      const isAReportDetail = this?.props?.dataItem?.inboxTypeId === 4;

      const actionName = (this?.props?.dataItem?.actionName || '').toString().toLowerCase()
      const inboxTypeKey = (this?.props?.dataItem?.inboxType || '').toString().toLowerCase()
      const isDeleteRequest = this?.props?.dataItem?.inboxTypeId === 5 ||
        this?.props?.dataItem?.inboxTypeId === 19 ||
        inboxTypeKey.includes('delete') ||
        actionName.includes('delete_document')
      // let hideTrash =
      //   Number(user.userMetaData.userMifirma.userType.id) === 3 ? true : false;
      // hideTrash =
      //   user.userMetaData.userMifirma.id !=
      //     this.props.dataItem.clientCreatorId
      //     ? true
      //     : false;
      if (isAReportDetail) showCancel = true
      // showCancel = isAReportDetail ? true : false;


      // if (this.props.dataItem.solicitudeStatus === "Completadas" || this.props.dataItem.solicitudeStatus === "Cancelado" || this.props.dataItem.hideTrash) {
      //   hideTrash = true;
      // }

      // if(selectedFilter) {
      //   hideTrash = true
      //   if(this.props.dataItem.solicitudeStatus === "Pendiente") {
      //     hideTrash = true
      //   } else if (this.props.dataItem.signRequestStatusId === 2 && selectedFilter === 2){
      //     hideTrash = false
      //   } else if (this.props.dataItem.signRequestStatusId === 2 && this.props.dataItem.userId === this.props.dataItem.user.id && selectedFilter==1) {
      //     hideTrash = false
      //   } else if (this.props.dataItem.signRequestStatusId === 2 && this.props.dataItem.userId != this.props.dataItem.user.id && selectedFilter==1){
      //     hideTrash = true
      //   }
      // }

      // if (inboxTypeId > 3) {
      //   hideTrash = true;
      // }

      let solicitudeUrlToUse = this.props.dataItem.solicitudeUrl

      const docIdFromItem = extractDocumentId(this.props.dataItem)
      if (isDeleteRequest && docIdFromItem) {
        solicitudeUrlToUse = {
          pathname: '/digital-vault/bin',
          search: `?documentId=${docIdFromItem}&fromDelete=true`
        }
      } else if (isDeleteRequest && this.props.dataItem.expedienteId) {
        solicitudeUrlToUse = {
          pathname: '/digital-vault/bin',
          search: `?expedienteId=${this.props.dataItem.expedienteId}&fromDelete=true`
        };
      } else if (isDeleteRequest) {
        const solicitudeId = this?.props?.dataItem?.solicitudeId || this?.props?.dataItem?.name || ''
        const qs = new URLSearchParams()
        if (solicitudeId) qs.set('', solicitudeId)
        qs.set('fromDelete', 'true')
        qs.set('autoOpen', 'true')
        solicitudeUrlToUse = { pathname: '/digital-vault/bin', search: `?${qs.toString()}` }
      }

      return (
        <td className={styleCol4}>
          <div className="actionGridEnd">
            <Container
              inboxTypeId={inboxTypeId}
              killMe={killMe}
              solicitudeUrl={solicitudeUrlToUse}
              id={this.props.dataItem.id}
              view={view}
              setIsShowAutorizationModal={setIsShowAutorizationModal}
              userTypeId={true}
              dataItem={this.props.dataItem}
            >
              <React.Fragment>
                <div
                  style={{ display: "inline-block", margin: "auto" }}
                  className={`CellDetailSignatureRequest-button-signs-details-new ${visibilityIcon ? "visibilityIconHide" : ""
                    }`}
                >
                  <Tooltip
                    openDelay={600}
                    position="top"
                    anchorElement="target"
                    tooltipClassName="tooltipGeneralStyle"
                  >
                    <span
                      title={tooltipDetail}
                      onClick={() => {
                        edit(this.props.dataItem);
                      }}
                    >
                      {" "}
                      {seeDetail}{" "}
                    </span>
                  </Tooltip>
                </div>
                {/* {visibilityIcon && (
                <div className="visibilityIcon" style={{ margin: "auto" }}>
                  <SvgIcon>
                    <path d="M0 0h24v24H0V0z" fill="none" />
                    <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" />
                  </SvgIcon>
                </div>
              )} */}
                <div
                  className={`signature-receive-cellActions-mobileExpanded-new`}
                  onClick={() => {
                    edit(this.props.dataItem);
                  }}
                >
                  <img
                    className="cellActions-icon-arrow"
                    alt={"cellActions-arrow"}
                    src={ArrowBtnMobile}
                  />
                </div>
              </React.Fragment>
            </Container>
            {isAReportDetail !== true &&
              user.userMetaData.userMifirma.userType.id !==
              Number(process.env.REACT_APP_USER_TYPE_INVITADO) ? (
              <div className="icon-tracking ">
                <Link
                  to={{
                    pathname: `/document-tracking/${this.props.dataItem.solicitudeId}`,
                    params: { dataItem: this.props.dataItem },
                  }}
                >
                  <Tooltip
                    openDelay={600}
                    position="top"
                    anchorElement="target"
                    tooltipClassName="tooltipGeneralStyle"
                  >
                    <img
                      title={tooltipTracking}
                      src="https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/icon_tracking_document.png"
                      width={20}
                      alt="tracking-icon"
                    ></img>
                  </Tooltip>
                </Link>
              </div>
            ) : null}
            {showCancel && (
              <div className="icon-trash">
                <Tooltip
                  openDelay={600}
                  position="top"
                  anchorElement="target"
                  tooltipClassName="tooltipGeneralStyle"
                >
                  <button
                    className="button-sign-request-delete"
                    onClick={() => {
                      toggleDialogDeleteRequest(this.props.dataItem);
                    }}
                  >
                    <i
                      title={tooltipDelete}
                      className="k-icon k-i-delete k-i-trash"
                    ></i>
                  </button>
                </Tooltip>
              </div>
            )}
          </div>
        </td>
      );
    }
  };
}
